export const MARKET_KR = 'KR';
export const MARKET_GLOBAL = 'GLOBAL';

export const PAYMENT_PRODUCTS = {
    mega_premium: {
        id: 'mega_premium',
        market: MARKET_KR,
        currency: 'KRW',
        provider: 'toss',
        amount: 9900,
        creditCount: 0,
        label: 'Mega Premium Report',
        route: '/premium',
    },
    love_premium: {
        id: 'love_premium',
        market: MARKET_KR,
        currency: 'KRW',
        provider: 'toss',
        amount: 9900,
        creditCount: 0,
        label: 'Love Premium Report',
        route: '/premium/love',
    },
    chemistry_premium: {
        id: 'chemistry_premium',
        market: MARKET_KR,
        currency: 'KRW',
        provider: 'toss',
        amount: 500,
        title: '1회 이용권',
        title_en: '1-use Pass',
        label: '케미 분석 + 프리미엄 해석 1회권',
        route: '/chemistry-test/result',
        uses: 1,
        creditCount: 1,
        description: '추가 케미 분석 1회와 해당 결과의 프리미엄 해석',
        description_en: 'One additional chemistry analysis with its premium interpretation',
        tagline: '가볍게 한 번 확인하기',
        tagline_en: 'Check one pairing',
        badge: '',
        badge_en: '',
        perUsePrice: 500,
    },
    chemistry_premium_1: {
        id: 'chemistry_premium_1',
        market: MARKET_KR,
        currency: 'KRW',
        provider: 'toss',
        amount: 500,
        title: '1회 이용권',
        title_en: '1-use Pass',
        label: '케미 분석 + 프리미엄 해석 1회권',
        route: '/chemistry-test/result',
        uses: 1,
        creditCount: 1,
        description: '추가 케미 분석 1회와 해당 결과의 프리미엄 해석',
        description_en: 'One additional chemistry analysis with its premium interpretation',
        tagline: '가볍게 한 번 확인하기',
        tagline_en: 'Check one pairing',
        badge: '',
        badge_en: '',
        perUsePrice: 500,
    },
    chemistry_premium_10: {
        id: 'chemistry_premium_10',
        market: MARKET_KR,
        currency: 'KRW',
        provider: 'toss',
        amount: 5000,
        title: '12회 이용권',
        title_en: '12-use Pass',
        label: '케미 분석 + 프리미엄 해석 12회권',
        route: '/chemistry-test/result',
        uses: 12,
        creditCount: 12,
        description: '친구, 연인, 소개팅 상대까지 여러 번 테스트하기 좋아요',
        description_en: 'Compare friends, partners, and new connections',
        tagline: '여러 명과 비교해보기',
        tagline_en: 'Compare several people',
        badge: '추천',
        badge_en: 'Recommended',
        perUsePrice: 417,
        recommended: true,
    },
    chemistry_premium_30: {
        id: 'chemistry_premium_30',
        market: MARKET_KR,
        currency: 'KRW',
        provider: 'toss',
        amount: 10000,
        title: '30회 이용권',
        title_en: '30-use Pass',
        label: '케미 분석 + 프리미엄 해석 30회권',
        route: '/chemistry-test/result',
        uses: 30,
        creditCount: 30,
        description: '단체 테스트나 여러 조합 분석에 적합해요',
        description_en: 'Designed for groups and multiple pairing analyses',
        tagline: '콘텐츠처럼 마음껏 테스트',
        tagline_en: 'Explore without limits',
        badge: '최대 할인',
        badge_en: 'Best Value',
        perUsePrice: 333,
    },
    chemistry_single_global: {
        id: 'chemistry_single_global',
        market: MARKET_GLOBAL,
        currency: 'USD',
        provider: 'paypal',
        amount: 0.49,
        price: '$0.49',
        title: '1-use Pass',
        title_en: '1-use Pass',
        label: 'Chemistry Premium 1-use Pass',
        route: '/chemistry-test/result',
        uses: 1,
        creditCount: 1,
        description: 'One additional chemistry analysis with its premium interpretation',
        description_en: 'One additional chemistry analysis with its premium interpretation',
        tagline: 'Check one pairing',
        tagline_en: 'Check one pairing',
        badge: '',
        badge_en: '',
        perUsePrice: 0.49,
    },
    chemistry_12_global: {
        id: 'chemistry_12_global',
        market: MARKET_GLOBAL,
        currency: 'USD',
        provider: 'paypal',
        amount: 4.99,
        price: '$4.99',
        title: '12-use Pass',
        title_en: '12-use Pass',
        label: 'Chemistry Premium 12-use Pass',
        route: '/chemistry-test/result',
        uses: 12,
        creditCount: 12,
        description: 'Compare friends, partners, and new connections',
        description_en: 'Compare friends, partners, and new connections',
        tagline: 'Compare several people',
        tagline_en: 'Compare several people',
        badge: 'Recommended',
        badge_en: 'Recommended',
        perUsePrice: 0.42,
        recommended: true,
    },
    chemistry_30_global: {
        id: 'chemistry_30_global',
        market: MARKET_GLOBAL,
        currency: 'USD',
        provider: 'paypal',
        amount: 9.99,
        price: '$9.99',
        title: '30-use Pass',
        title_en: '30-use Pass',
        label: 'Chemistry Premium 30-use Pass',
        route: '/chemistry-test/result',
        uses: 30,
        creditCount: 30,
        description: 'Designed for groups and multiple pairing analyses',
        description_en: 'Designed for groups and multiple pairing analyses',
        tagline: 'Explore without limits',
        tagline_en: 'Explore without limits',
        badge: 'Best Value',
        badge_en: 'Best Value',
        perUsePrice: 0.33,
    },
    beyond_premium: {
        id: 'beyond_premium',
        market: MARKET_KR,
        currency: 'KRW',
        provider: 'toss',
        amount: 9900,
        creditCount: 0,
        label: 'Beyond Premium Report',
        route: '/premium/beyond',
    },
};

const PRODUCT_MARKET_EQUIVALENTS = {
    chemistry_premium: { KR: 'chemistry_premium_1', GLOBAL: 'chemistry_single_global' },
    chemistry_premium_1: { KR: 'chemistry_premium_1', GLOBAL: 'chemistry_single_global' },
    chemistry_premium_10: { KR: 'chemistry_premium_10', GLOBAL: 'chemistry_12_global' },
    chemistry_premium_30: { KR: 'chemistry_premium_30', GLOBAL: 'chemistry_30_global' },
    chemistry_single_global: { KR: 'chemistry_premium_1', GLOBAL: 'chemistry_single_global' },
    chemistry_12_global: { KR: 'chemistry_premium_10', GLOBAL: 'chemistry_12_global' },
    chemistry_30_global: { KR: 'chemistry_premium_30', GLOBAL: 'chemistry_30_global' },
};

export const CHEMISTRY_PAYMENT_PRODUCTS_KR = [
    PAYMENT_PRODUCTS.chemistry_premium_1,
    PAYMENT_PRODUCTS.chemistry_premium_10,
    PAYMENT_PRODUCTS.chemistry_premium_30,
];

export const CHEMISTRY_PAYMENT_PRODUCTS_GLOBAL = [
    PAYMENT_PRODUCTS.chemistry_single_global,
    PAYMENT_PRODUCTS.chemistry_12_global,
    PAYMENT_PRODUCTS.chemistry_30_global,
];

export const CHEMISTRY_PAYMENT_PRODUCTS = CHEMISTRY_PAYMENT_PRODUCTS_KR;

export function normalizeMarket(market) {
    return market === MARKET_GLOBAL || market === 'global' ? MARKET_GLOBAL : MARKET_KR;
}

export function getChemistryPaymentProducts(market = MARKET_KR) {
    return normalizeMarket(market) === MARKET_GLOBAL ? CHEMISTRY_PAYMENT_PRODUCTS_GLOBAL : CHEMISTRY_PAYMENT_PRODUCTS_KR;
}

export function getMarketProductId(productId, market = MARKET_KR) {
    const normalized = normalizeMarket(market);
    const equivalent = PRODUCT_MARKET_EQUIVALENTS[productId]?.[normalized];
    if (equivalent) return equivalent;
    const product = PAYMENT_PRODUCTS[productId];
    return product?.market === normalized ? productId : null;
}

export function getPaymentProduct(productId) {
    return PAYMENT_PRODUCTS[productId] || null;
}

export function formatProductPrice(product, language = 'ko') {
    if (!product) return '';
    if (product.currency === 'USD') return product.price || `$${Number(product.amount).toFixed(2)}`;
    return language.startsWith('en') ? `KRW ${Number(product.amount).toLocaleString()}` : `${Number(product.amount).toLocaleString()}원`;
}

export function formatPerUsePrice(product, language = 'ko') {
    if (!product) return '';
    if (product.currency === 'USD') return `$${Number(product.perUsePrice).toFixed(2)} per use`;
    return language.startsWith('en')
        ? `KRW ${Number(product.perUsePrice).toLocaleString()} per use`
        : `회당 ${Number(product.perUsePrice).toLocaleString()}원`;
}
